import type { NewsTranslations } from "../interfaces/news";

export const newsTranslations: NewsTranslations = {
  page_title: "News and announcements",
  page_subtitle: "View active notes and search by title or description.",
  search_placeholder: "Search notes by title, description",
  search_aria: "Search",
  new_note_button: "New note",

  error_load: "Error loading notes.",
  error_create: "Error creating the note.",
  error_delete: "Error deleting the note.",

  loading_notes: "Loading notes…",
  searching: "Searching…",
  empty_search: "No notes match your search.",
  empty_no_notes: "No active notes to display.",
  load_more_aria: "Show more notes",
  load_more_loading: "Loading…",
  load_more: "Show more",

  card_pinned_aria: "Pinned",
  card_delete_aria: "Delete note",
  card_attachments_aria: "Attachments",
  card_attachments_section_title: "Attachments",
  card_attachments_count: "{{count}} file(s)",
  card_attachment_download_title: "Download file {{n}}",
  card_attachment_download_aria: "Download file {{n}}",
  card_attachment_download_error: "Error downloading the file.",

  category_WORK_PERMIT: "Work permit",
  category_SCHEDULED_MAINTENANCE: "Scheduled maintenance",
  category_INCIDENT: "Incident",
  category_GENERAL: "General",
  category_REMINDER: "Reminder",
  category_URGENT_NOTICE: "Urgent notice",
  category_PROCESS_CHANGE: "Process change",
  category_CLIENT_ISSUE: "Client issue",
  category_TRAINING: "Training",
  category_MEETING: "Meeting",

  priority_LOW: "Low",
  priority_MEDIUM: "Medium",
  priority_HIGH: "High",
  priority_URGENT: "Urgent",

  modal_new_title: "New note",
  modal_close_aria: "Close",
  modal_label_title: "Title",
  modal_title_placeholder: "Note title",
  modal_label_content: "Content",
  modal_content_placeholder: "Note content",
  modal_label_category: "Category",
  modal_category_placeholder: "Select category",
  modal_label_priority: "Priority",
  modal_priority_placeholder: "Select priority",
  modal_pin_label: "Pin note",
  modal_pin_aria: "Pin note",
  modal_label_attachments: "Attachments (optional)",
  modal_attachments_description: "PNG, JPG, WebP or PDF up to 10 MB. You can choose multiple files.",
  modal_attachments_instruction: "Click to select or drag files here",
  modal_cancel: "Cancel",
  modal_creating: "Creating…",
  modal_create_button: "Create note",

  validation_title_required: "Title is required.",
  validation_title_length: "Title must be between {{min}} and {{max}} characters.",
  validation_content_required: "Content is required.",
  validation_category_required: "Category is required.",
  validation_priority_required: "Priority is required.",

  delete_modal_title: "Delete note",
  delete_modal_cancel: "Cancel",
  delete_modal_confirm: "Delete",
  delete_modal_warning: "This action cannot be undone.",
  delete_modal_message_with_title:
    "Are you sure you want to delete the note «{{title}}»? This action cannot be undone.",
  delete_modal_message_no_title: "Are you sure you want to delete this note? This action cannot be undone.",
};
